import React, { useEffect, useMemo, useRef, useState } from "react";
import { productDraftApiService } from "../../../service/admin/productDraftApiService";
import { ProductsApiService } from "../../../service/website/productsApiService";
import { useLoader } from "../../../base/context/LoaderProvider";
import { ToastTypes, useMessage } from "../../../base/context/MessageProvider";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaSync, FaDownload, FaCheckCircle, FaTrash } from "react-icons/fa";
import DeletePopUp from "../../../component/library/deletePopUp";
import ExcelTable from "../../../component/library/excelTable";
import { exportToCSV } from "react-easy-export";
import ExcelJS from "exceljs";
import { getAuthLocalStorage } from "../../../storage/localStorage";
// import Logo from "../../../website/assets/images/common/logo_no_image.png";
import "./style.css";
import { generateProductUrl } from '../../../utils/productUrlUtils';
import BulkDimensionUpdate, { VariantDetailsModal } from "./BulkDimensionUpdate";

const DRAFT_BATCH_PAGE_SIZE = 10;

const INITIAL_DRAFT_FILTERS = {
  search: "",
  status: "",
  source: "",
  errorFilter: "",
  globalCategoryThirdId: "",
  globalCategoryThirdIds: [],
  createdFrom: "",
  createdTo: "",
  batchId: "",
  isWhiteImageAvailable: "",
  moqFrom: "",
  moqTo: "",
};

export default function ProductDraftsList() {
  const [draftData, setDraftData] = useState([]);
  const [filters, setFilters] = useState(INITIAL_DRAFT_FILTERS);
  const [globalCategoryFacets, setGlobalCategoryFacets] = useState([]);
  const [globalCategoryFacetOffset, setGlobalCategoryFacetOffset] = useState(0);
  const [globalCategoryFacetHasMore, setGlobalCategoryFacetHasMore] = useState(false);
  const [globalCategoryFacetLoading, setGlobalCategoryFacetLoading] = useState(false);
  const [globalCategoryFacetSearch, setGlobalCategoryFacetSearch] = useState("");
  const [globalCategoryFilterOpen, setGlobalCategoryFilterOpen] = useState(false);
  const [globalCategoryFacetTotal, setGlobalCategoryFacetTotal] = useState(0);
  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState({ currentPage: 1, totalPages: 1, totalItems: 0 });
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [selectedDrafts, setSelectedDrafts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [translatedSellerNames, setTranslatedSellerNames] = useState({});
  const [exportProcessing, setExportProcessing] = useState(false);
  const [exportStatus, setExportStatus] = useState("");
  const [exportProgress, setExportProgress] = useState(0);
  const [exportSkuTemplateLoading, setExportSkuTemplateLoading] = useState(false);
  const [variantModalRow, setVariantModalRow] = useState(null);
  const navigate = useNavigate();
  const loader = useLoader();
  const message = useMessage();
  const globalCategoryFilterRef = useRef(null);
  const batchFilterRef = useRef(null);
  const moqFilterRef = useRef(null);
  const bulkUploadRef = useRef(null);
  const batchActiveSearchRef = useRef("");
  const facetInFlightKeyRef = useRef("");
  const lastFacetBaseKeyRef = useRef("");

  const [batchPickerOpen, setBatchPickerOpen] = useState(false);
  const [batchPanelSearch, setBatchPanelSearch] = useState("");
  const [batchSuggestions, setBatchSuggestions] = useState([]);
  const [batchLoading, setBatchLoading] = useState(false);
  const [batchLoadingMore, setBatchLoadingMore] = useState(false);
  const [batchHasMore, setBatchHasMore] = useState(false);

  const [moqPickerOpen, setMoqPickerOpen] = useState(false);
  const [moqPanelFrom, setMoqPanelFrom] = useState("");
  const [moqPanelTo, setMoqPanelTo] = useState("");

  const authData = getAuthLocalStorage();
  const currentUserId = authData?.loginHeader || null;

  const handleOnChange = (e) => setFilters({ ...filters, [e.target.name]: e.target.value });

  const normalizeUrl = (url) => {
    if (!url) return "";
    try { return String(url).replace(/^http:\/\//, "https://"); } catch { return url; }
  };

  const numericValue = (value) => {
    if (typeof value === "number" && Number.isFinite(value)) return value;
    if (!value) return 0;
    const parsed = parseFloat(String(value).replace(/[^0-9.\-]/g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const formatPrice = (value, symbol = "₹") => {
    if (value == null || !Number.isFinite(numericValue(value))) return null;
    const num = numericValue(value);
    return `${symbol}${num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const getVariantMixPrices = (item) => {
    const vars = item?.variations || [];
    if (!vars.length) {
      const vp = numericValue(item.vendor_price);
      return { minAp: vp, maxAp: vp, minCp: null, maxCp: null };
    }
    let minAp = null, maxAp = null, minCp = null, maxCp = null;
    for (const v of vars) {
      const ap = typeof v.ap === "number" && Number.isFinite(v.ap) ? v.ap : (typeof v.price === "number" && Number.isFinite(v.price) ? v.price : null);
      const cp = typeof v.cp === "number" && Number.isFinite(v.cp) ? v.cp : (typeof v.consignPrice === "number" && Number.isFinite(v.consignPrice) ? v.consignPrice : null);
      if (ap != null) {
        if (minAp == null || ap < minAp) minAp = ap;
        if (maxAp == null || ap > maxAp) maxAp = ap;
      }
      if (cp != null) {
        if (minCp == null || cp < minCp) minCp = cp;
        if (maxCp == null || cp > maxCp) maxCp = cp;
      }
    }
    if (minAp == null) minAp = numericValue(item.vendor_price);
    if (maxAp == null) maxAp = minAp;
    return { minAp, maxAp, minCp, maxCp };
  };

  const formatDate = (value) => {
    if (!value) return "-";
    try {
      return new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch { return "-"; }
  };

  const truncateText = (text = "", maxLength = 50) => {
    if (typeof text !== "string") return "";
    return text.length > maxLength ? `${text.substring(0, maxLength)}…` : text;
  };

  // Helper function to convert column index (0-based) to Excel column letter (A, B, C, ..., Z, AA, AB, ...)
  const getExcelColumnLetter = (colIndex) => {
    let result = '';
    let num = colIndex;
    while (num >= 0) {
      result = String.fromCharCode(65 + (num % 26)) + result;
      num = Math.floor(num / 26) - 1;
    }
    return result;
  };

  const handleExportCsv = async () => {
    setExportProcessing(true);
    setExportProgress(0);
    setExportStatus("Preparing export...");
    try {
    const source = selectedDrafts.length ? selectedDrafts : tableRows;
      
      if (source.length === 0) {
        message.showToast("No data to export", ToastTypes.WARNING);
        setExportProcessing(false);
        return;
      }
      
      // Use existing data from table (no need to fetch again)
      setExportProgress(10);
      setExportStatus(`Preparing ${source.length} product(s) for export...`);
      const fullProductData = source.map((entry) => {
        // Use raw data that's already available in the table
        return entry.raw || entry;
      });

      // First pass: Find maximum number of attributes in any single variant
      let maxAttributeCount = 0;
      fullProductData.forEach((product) => {
        const variations = product.variations || [];
        variations.forEach((variant) => {
          if (variant && Array.isArray(variant.skuAttributes)) {
            const attributeCount = variant.skuAttributes.filter(attr => {
              const attrName = attr.attributeNameTrans || attr.attributeName || "";
              const attrValue = attr.valueTrans || attr.value || "";
              return attrName && attrValue;
            }).length;
            if (attributeCount > maxAttributeCount) {
              maxAttributeCount = attributeCount;
            }
          }
        });
      });

      // Find maximum imgUrl array length across all products
      let maxImgUrlLength = 0;
      fullProductData.forEach((product) => {
        const imgUrlLength = Array.isArray(product.imgUrl) ? product.imgUrl.length : 0;
        if (imgUrlLength > maxImgUrlLength) {
          maxImgUrlLength = imgUrlLength;
        }
      });

      // Create export data with one row per variant
      const exportData = [];
      
      fullProductData.forEach((product) => {
        const variations = product.variations || [];
        // Normalize image URL
        const mainImage = product.imgUrl?.[0] ? normalizeUrl(product.imgUrl[0]) : "";
        const productSku = product.sku || product.parentSku || "";

        // Helper function to extract attributes from skuAttributes as ordered array
        const extractAttributesArray = (variant) => {
          const attributes = [];
          if (variant && Array.isArray(variant.skuAttributes)) {
            variant.skuAttributes.forEach((attr) => {
              const attrName = attr.attributeNameTrans || attr.attributeName || "";
              const attrValue = attr.valueTrans || attr.value || "";
              if (attrName && attrValue) {
                attributes.push(`${attrName} - ${attrValue}`);
              }
            });
          }
          return attributes;
        };

        // Helper function to create export row
        const createExportRow = (variant = null) => {
          // Use variant image if available, otherwise use product image
          const variantImage = variant?.imgUrl?.[0] || variant?.image || "";
          const displayImage = variantImage ? normalizeUrl(variantImage) : mainImage;
          
          // Extract attributes from skuAttributes as ordered array
          const variantAttributesArray = variant ? extractAttributesArray(variant) : [];
          
          // Extract image description from variant skuAttributes
          const imageDescription = variant && Array.isArray(variant.skuAttributes) 
            ? variant.skuAttributes.find(attr => attr.skuImageUrl)?.skuImageUrl || ""
            : "";
          
          const row = {
            "Image": "", // Blank column for formula
            "Image URL": displayImage,
            "Product Name": product.title || "",
            "Product SKU": (() => {
              // Keep as string to prevent scientific notation in Excel
              if (productSku) {
                return String(productSku);
              }
              return "";
            })(),
            "Variant SKU": variant ? (() => {
              // Keep as string to prevent scientific notation in Excel
              const sku = variant.sku || variant.skuId || variant.specId || "";
              if (sku) {
                return String(sku);
              }
              return "";
            })() : (() => {
              // Keep as string to prevent scientific notation in Excel
              const sku = product.sku || "";
              if (sku) {
                return String(sku);
              }
              return "";
            })(),
            // Dynamic attribute columns - based on maximum count, fill in order
            ...(Array.from({ length: maxAttributeCount }, (_, index) => {
              const attrValue = variantAttributesArray[index] || "";
              return { [`Attribute ${index + 1}`]: attrValue };
            }).reduce((acc, obj) => ({ ...acc, ...obj }), {})),
            "Category": "",
            "Quantity": variant ? (variant.amountOnSale || 0) : (product.quantity || 0),
            "Weight": variant ? (variant.weight || 0) : (product.weight || 0),
            "Length": variant ? (variant.length || 0) : (product.length || ""),
            "Width": variant ? (variant.width || 0) : (product.width || ""),
            "Height": variant ? (variant.height || 0) : (product.height || ""),
            "AP": variant ? (variant.ap || variant.actualPrice || "") : "",
            "CP": variant ? (variant.consignPrice || variant.cp || "") : "",
            "DS Final Price": variant ? formatPrice(variant.finalPrice || 0) : formatPrice(product.sp || 0),
            "WS Final Price": variant ? formatPrice(variant.wholesaleFinalPrice || 0) : "",
            "Variant Image": "", // Blank column for formula
            "Variant Image URL": variant && Array.isArray(variant.skuAttributes) 
              ? (variant.skuAttributes.find(attr => attr.skuImageUrl)?.skuImageUrl || "") 
              : "",
            "Offer ID": product.offerId || "",
            "GST": product.gst || "",
            "HSN": product.hsn || "",
            "Handling Days": product.handling_days || "",
            "Max Order Quantity": product.max_order_quantity || product.moq || "",
            "Local Shipping": variant ? (variant.localShipping || variant.ls || 0) : (product.local_shipping || 0),
            "Generic Keywords": product.generic_keywords || "",
            "Search Keywords": Array.isArray(product.keywordSearch) ? product.keywordSearch.join(", ") : (product.keywordSearch || ""),
            "Bullet Point 1": Array.isArray(product.bullet_points) ? (product.bullet_points[0] || "") : "",
            "Bullet Point 2": Array.isArray(product.bullet_points) ? (product.bullet_points[1] || "") : "",
            "Bullet Point 3": Array.isArray(product.bullet_points) ? (product.bullet_points[2] || "") : "",
            "Bullet Point 4": Array.isArray(product.bullet_points) ? (product.bullet_points[3] || "") : "",
            "Bullet Point 5": Array.isArray(product.bullet_points) ? (product.bullet_points[4] || "") : "",
            // Dynamic image columns based on imgUrl array length - blank column + URL column
            ...(Array.from({ length: maxImgUrlLength }, (_, index) => {
              const imgUrl = Array.isArray(product.imgUrl) && product.imgUrl[index] 
                ? normalizeUrl(product.imgUrl[index]) 
                : "";
              return { 
                [`Img ${index + 1}`]: "", // Blank column for formula
                [`Img ${index + 1} URL`]: imgUrl
              };
            }).reduce((acc, obj) => ({ ...acc, ...obj }), {})),
            "Description": product.description || "",
            "Image Description": product.img_description || "",
          };
          return row;
        };

        // If product has no variants, create one row with product data
        if (variations.length === 0) {
          exportData.push(createExportRow());
        } else {
          // Create one row for each variant
          variations.forEach((variant) => {
            exportData.push(createExportRow(variant));
          });
        }
      });

      // Export to Excel with column width based on content
      if (exportData.length === 0) {
        message.showToast("No data to export", ToastTypes.WARNING);
        setExportProcessing(false);
        return;
      }

      setExportProgress(30);
      setExportStatus(`Preparing Excel file with ${exportData.length} rows...`);
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Product Drafts');

      // Get all column keys from first row
      const columnKeys = Object.keys(exportData[0]);
      
      // Define columns with headers
      const columns = columnKeys.map((key) => ({
        header: key,
        key: key,
        width: 15, // Default width, will be adjusted
      }));

      worksheet.columns = columns;

      // Style header row
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF4472C4' }
      };
      headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
      headerRow.height = 20;

      setExportProgress(40);
      setExportStatus(`Adding data rows...`);
      // Add data rows
      for (let rowIndex = 0; rowIndex < exportData.length; rowIndex++) {
        // Update progress (70% to 90%)
        const dataProgress = 70 + Math.floor((rowIndex / exportData.length) * 20);
        setExportProgress(dataProgress);
        const rowData = exportData[rowIndex];
        const row = worksheet.addRow(rowData);
        const excelRowIndex = rowIndex + 2; // +2 because row 1 is header
        
        // Set row height
        row.height = 25;
        
        // Process each cell
        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
          
          // Format SKU columns as text to prevent scientific notation
          const columnKey = columnKeys[colNumber - 1];
          if (columnKey === 'Product SKU' || columnKey === 'Variant SKU') {
            cell.numFmt = '@'; // '@' is the text format code in Excel
            // Ensure value is treated as text
            if (cell.value !== null && cell.value !== undefined) {
              cell.value = String(cell.value);
            }
          }
        });
      }
      
      // Auto-fit columns based on content length
      let descriptionColumnWidth = null;
      
      // First pass: calculate all column widths and find Description column width
      columnKeys.forEach((key, index) => {
        const column = worksheet.getColumn(index + 1);
        
        // Set width for Image columns (blank columns for formulas)
        if (key === 'Image' || key === 'Variant Image' || (key.startsWith('Img ') && !key.endsWith(' URL'))) {
          column.width = 15; // Fixed width for blank image columns
          return;
        }
        
        // Set width for Image URL columns (containing URLs)
        if (key === 'Image URL' || key === 'Variant Image URL' || (key.startsWith('Img ') && key.endsWith(' URL'))) {
          let maxUrlLength = key.length; // Start with header length
          worksheet.getColumn(key).eachCell({ includeEmpty: false }, (cell) => {
            const cellValue = cell.value ? String(cell.value) : '';
            if (cellValue.length > maxUrlLength) {
              maxUrlLength = cellValue.length;
            }
          });
          const urlWidth = Math.min(50, Math.max(15, maxUrlLength + 5));
          column.width = urlWidth;
          return;
        }
        
        let maxLength = key.length; // Start with header length
        
        // Find max content length in this column
        worksheet.getColumn(key).eachCell({ includeEmpty: false }, (cell) => {
          const cellValue = cell.value ? String(cell.value) : '';
          if (cellValue.length > maxLength) {
            maxLength = cellValue.length;
          }
        });
        
        // Set width with padding (min 10, max 60 for better readability)
        const calculatedWidth = Math.min(60, Math.max(10, maxLength + 3));
        column.width = calculatedWidth;
        
        // Store Description column width
        if (key === 'Description') {
          descriptionColumnWidth = calculatedWidth;
        }
      });
      
      // Second pass: Set Image Description column width to match Description column width
      if (descriptionColumnWidth !== null) {
        columnKeys.forEach((key, index) => {
          if (key === 'Image Description') {
            const column = worksheet.getColumn(index + 1);
            column.width = descriptionColumnWidth;
          }
        });
      }

      // Generate buffer and download
      setExportProgress(80);
      setExportStatus("Generating Excel file...");
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Product_Drafts_Export.xlsx';
      link.style.display = 'none';
      
      // Append to body, trigger download, then remove
      document.body.appendChild(link);
      
      setExportProgress(95);
      setExportStatus("Downloading file...");
      
      // Use setTimeout to ensure the link is properly attached
      setTimeout(() => {
        link.click();
        setExportProgress(100);
        setExportStatus("Export completed!");
        
        // Clean up after a short delay
        setTimeout(() => {
          // Check if link still exists in DOM before removing
          if (link && link.parentNode) {
            try {
              document.body.removeChild(link);
            } catch (error) {
              console.warn("Link already removed:", error);
            }
          }
          // Always revoke URL to free memory
          if (url) {
            try {
              window.URL.revokeObjectURL(url);
            } catch (error) {
              console.warn("Error revoking URL:", error);
            }
          }
          message.showToast(`Exported ${exportData.length} rows (${fullProductData.length} products)`, ToastTypes.SUCCESS);
          setExportProcessing(false);
        }, 500);
      }, 100);
    } catch (error) {
      console.error("Export error:", error);
      message.showToast("Error exporting data: " + (error.message || "Unknown error"), ToastTypes.ERROR);
      setExportProcessing(false);
    }
  };

  const handleBulkPublish = async () => {
    if (!selectedDrafts.length) {
      message.showToast("Select drafts to publish", ToastTypes.WARNING);
      return;
    }
    loader.showLoading(true);
    try {
      const results = await Promise.all(
        selectedDrafts.map((entry) => {
          const item = entry.raw || entry;
          return productDraftApiService.updateProductDraft(item._id, { status: "5" })
            .then((res) => res?.status?.code === 200 ? "fulfilled" : "rejected")
            .catch(() => "rejected");
        })
      );
      const successCount = results.filter((s) => s === "fulfilled").length;
      if (successCount) message.showToast(`${successCount} draft(s) published`, ToastTypes.SUCCESS);
      setSelectedDrafts([]);
      fetchDraftsList();
    } finally {
      loader.showLoading(false);
    }
  };

  const handleBulkDelete = async () => {
    if (!selectedDrafts.length) {
      message.showToast("Select drafts to delete", ToastTypes.WARNING);
      return;
    }
    if (!window.confirm(`Delete ${selectedDrafts.length} draft(s)?`)) return;
    loader.showLoading(true);
    try {
      const results = await Promise.all(
        selectedDrafts.map((entry) => {
          const item = entry.raw || entry;
          return productDraftApiService.deleteProductDraft(item._id)
            .then((res) => res?.status?.code === 200 ? "fulfilled" : "rejected")
            .catch(() => "rejected");
        })
      );
      const successCount = results.filter((s) => s === "fulfilled").length;
      if (successCount) message.showToast(`${successCount} draft(s) deleted`, ToastTypes.SUCCESS);
      setSelectedDrafts([]);
      fetchDraftsList();
    } finally {
      loader.showLoading(false);
    }
  };

  const buildQueryParams = (filterState = filters, pageNum = page, pageLimit = limit) => {
    let q = `?page=${pageNum}&limit=${pageLimit}&sortBy=createdAt&sortOrder=desc`;
    if (filterState.search) q += `&search=${encodeURIComponent(filterState.search)}`;
    if (filterState.status) q += `&status=${encodeURIComponent(filterState.status)}`;
    if (filterState.source) q += `&source=${encodeURIComponent(filterState.source)}`;
    if (filterState.errorFilter) q += `&errorFilter=${encodeURIComponent(filterState.errorFilter)}`;
    if (Array.isArray(filterState.globalCategoryThirdIds) && filterState.globalCategoryThirdIds.length > 0) {
      q += `&thirdCategoryIds=${encodeURIComponent(filterState.globalCategoryThirdIds.join(","))}`;
    } else if (filterState.globalCategoryThirdId) {
      q += `&thirdCategoryId=${encodeURIComponent(filterState.globalCategoryThirdId)}`;
    }
    // if (filterState.createdFrom) q += `&createdFrom=${encodeURIComponent(filterState.createdFrom)}`;
    // if (filterState.createdTo) q += `&createdTo=${encodeURIComponent(filterState.createdTo)}`;
    if (filterState.batchId) q += `&batchId=${encodeURIComponent(String(filterState.batchId).trim())}`;
    if (filterState.isWhiteImageAvailable) {
      q += `&isWhiteImageAvailable=${encodeURIComponent(filterState.isWhiteImageAvailable)}`;
    }
    if (filterState.moqFrom !== "" && filterState.moqFrom != null) {
      q += `&moqFrom=${encodeURIComponent(String(filterState.moqFrom).trim())}`;
    }
    if (filterState.moqTo !== "" && filterState.moqTo != null) {
      q += `&moqTo=${encodeURIComponent(String(filterState.moqTo).trim())}`;
    }
    return q;
  };

  const loadBatchRows = async (offset, searchStr, append) => {
    const search = String(searchStr ?? "").trim();
    if (offset === 0) setBatchLoading(true);
    else setBatchLoadingMore(true);
    try {
      const res = await productDraftApiService.listDraftSkuUploadBatches({
        search,
        offset,
        limit: DRAFT_BATCH_PAGE_SIZE,
      });
      if (res?.status?.code === 200) {
        const batches = Array.isArray(res.data?.batches) ? res.data.batches : [];
        const hasMore = Boolean(res.data?.hasMore);
        setBatchSuggestions((prev) => (append ? [...prev, ...batches] : batches));
        setBatchHasMore(hasMore);
      } else {
        if (!append) setBatchSuggestions([]);
        setBatchHasMore(false);
      }
    } catch {
      if (!append) setBatchSuggestions([]);
      setBatchHasMore(false);
    } finally {
      setBatchLoading(false);
      setBatchLoadingMore(false);
    }
  };

  // Translate Chinese seller (company) names to English
  const translateSellerNames = async (drafts) => {
    const chineseNames = {};
    (drafts || []).forEach((item) => {
      const name = item.sellerCompanyName || item.companyName || "";
      if (name && /[\u4e00-\u9fa5]/.test(name) && !translatedSellerNames[name]) {
        chineseNames[name] = name;
      }
    });
    if (Object.keys(chineseNames).length === 0) return;
    try {
      const translateData = { sellerNames: chineseNames };
      const res = await ProductsApiService.translateMandarinToEnglish(translateData, "en");
      if (res.status?.code === 200 && res.data?.sellerNames) {
        setTranslatedSellerNames((prev) => ({ ...prev, ...res.data.sellerNames }));
      }
    } catch (error) {
      console.error("Translation error:", error);
    }
  };

  const fetchDraftsList = (override = {}) => {
    const filterState = override.filters ?? filters;
    const pageNum = override.page ?? page;
    const categoryFacetSearch = override.globalCategoryFacetSearch ?? globalCategoryFacetSearch;
    const facetBaseKey = `${filterState.errorFilter || ""}|${filterState.createdFrom || ""}|${filterState.createdTo || ""}|${categoryFacetSearch || ""}|${filterState.batchId || ""}|${filterState.isWhiteImageAvailable || ""}|${filterState.status || ""}|${filterState.moqFrom || ""}|${filterState.moqTo || ""}`;
    setLoading(true);
    productDraftApiService.getAllProductDrafts(buildQueryParams(filterState, pageNum, override.limit ?? limit))
      .then((res) => {
        setLoading(false);
        setInitialLoading(false);
        if (res.status.code === 200) {
          setDraftData(res.data.drafts);
          setPages({
            currentPage: res.data.pagination.currentPage,
            totalPages: res.data.pagination.totalPages,
            totalItems: res.data.pagination.totalItems,
          });
          setPage(res.data.pagination.currentPage);
          translateSellerNames(res.data.drafts);
          if (lastFacetBaseKeyRef.current !== facetBaseKey) {
            lastFacetBaseKeyRef.current = facetBaseKey;
            fetchGlobalCategoryFacets({
              append: false,
              offset: 0,
              searchTerm: categoryFacetSearch,
              filters: filterState,
            });
          }
        } else if (res.status.code === 402) {
          navigate("/login");
        } else {
          message.showToast(res.error.message, ToastTypes.ERROR);
        }
      })
      .catch((err) => {
        message.showToast(err?.message || "Server error", ToastTypes.ERROR);
        setLoading(false);
        setInitialLoading(false);
      });
  };

  const fetchGlobalCategoryFacets = (opts = {}) => {
    const {
      append = false,
      offset: requestedOffset = 0,
      searchTerm = globalCategoryFacetSearch,
      filters: filterState = filters,
    } = opts;
    const reqKey = `${filterState.errorFilter || ""}|${filterState.createdFrom || ""}|${filterState.createdTo || ""}|${filterState.batchId || ""}|${filterState.isWhiteImageAvailable || ""}|${filterState.status || ""}|${filterState.moqFrom || ""}|${filterState.moqTo || ""}|${searchTerm || ""}|${requestedOffset}|${append ? 1 : 0}`;
    if (facetInFlightKeyRef.current === reqKey) return Promise.resolve();
    facetInFlightKeyRef.current = reqKey;
    setGlobalCategoryFacetLoading(true);
    return productDraftApiService
      .getDraftGlobalCategoryFacets({
        errorFilter: filterState.errorFilter || "",
        createdFrom: filterState.createdFrom || "",
        createdTo: filterState.createdTo || "",
        search: searchTerm || "",
        offset: requestedOffset,
        limit: 100,
        batchId: filterState.batchId || "",
        isWhiteImageAvailable: filterState.isWhiteImageAvailable || "",
        status: filterState.status || "",
        moqFrom: filterState.moqFrom ?? "",
        moqTo: filterState.moqTo ?? "",
      })
      .then((res) => {
        if (res?.status?.code !== 200) throw new Error("Failed to load global categories");
        const options = Array.isArray(res?.data?.options) ? res.data.options : [];
        const hasMore = !!res?.data?.pagination?.hasMore;
        const total = Number(res?.data?.pagination?.total || 0);
        const nextOffset = requestedOffset + options.length;
        setGlobalCategoryFacets((prev) => (append ? [...prev, ...options] : options));
        setGlobalCategoryFacetHasMore(hasMore);
        setGlobalCategoryFacetOffset(nextOffset);
        setGlobalCategoryFacetTotal(total);
      })
      .catch((err) => {
        message.showToast(err?.message || "Failed to load global categories", ToastTypes.ERROR);
        if (!append) setGlobalCategoryFacets([]);
        setGlobalCategoryFacetHasMore(false);
        if (!append) setGlobalCategoryFacetTotal(0);
      })
      .finally(() => {
        facetInFlightKeyRef.current = "";
        setGlobalCategoryFacetLoading(false);
      });
  };

  const normalizedCategorySearch = String(globalCategoryFacetSearch || "").trim();
  const isCategoryIdSearch = /^\d+$/.test(normalizedCategorySearch);
  const shouldFetchCategoryByName = normalizedCategorySearch.length >= 3;
  const shouldFetchCategories =
    !normalizedCategorySearch || isCategoryIdSearch || shouldFetchCategoryByName;

  useEffect(() => {
    const t = setTimeout(() => {
      if (!shouldFetchCategories) {
        setGlobalCategoryFacets([]);
        setGlobalCategoryFacetHasMore(false);
        setGlobalCategoryFacetOffset(0);
        setGlobalCategoryFacetTotal(0);
        return;
      }
      lastFacetBaseKeyRef.current = `${filters.errorFilter || ""}|${filters.createdFrom || ""}|${filters.createdTo || ""}|${globalCategoryFacetSearch || ""}|${filters.batchId || ""}|${filters.isWhiteImageAvailable || ""}|${filters.status || ""}|${filters.moqFrom || ""}|${filters.moqTo || ""}`;
      fetchGlobalCategoryFacets({ append: false, offset: 0, searchTerm: globalCategoryFacetSearch });
    }, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalCategoryFacetSearch, shouldFetchCategories]);

  useEffect(() => {
    const onDocMouseDown = (event) => {
      if (!globalCategoryFilterOpen) return;
      if (globalCategoryFilterRef.current && !globalCategoryFilterRef.current.contains(event.target)) {
        setGlobalCategoryFilterOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocMouseDown);
    return () => document.removeEventListener("mousedown", onDocMouseDown);
  }, [globalCategoryFilterOpen]);

  useEffect(() => {
    if (!batchPickerOpen) return undefined;
    batchActiveSearchRef.current = "";
    loadBatchRows(0, "", false);
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchPickerOpen]);

  useEffect(() => {
    if (!batchPickerOpen) return undefined;
    const onDoc = (event) => {
      if (batchFilterRef.current && !batchFilterRef.current.contains(event.target)) {
        setBatchPickerOpen(false);
      }
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [batchPickerOpen]);

  useEffect(() => {
    if (!moqPickerOpen) return undefined;
    const onDoc = (event) => {
      if (moqFilterRef.current && !moqFilterRef.current.contains(event.target)) {
        setMoqPickerOpen(false);
      }
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [moqPickerOpen]);

  useEffect(() => {
    fetchDraftsList();
  }, [page, limit, filters.status, filters.errorFilter, filters.globalCategoryThirdId, filters.globalCategoryThirdIds, filters.createdFrom, filters.createdTo, filters.batchId, filters.isWhiteImageAvailable, filters.moqFrom, filters.moqTo]);

  const searchDrafts = () => { setPage(1); fetchDraftsList(); };

  const toggleGlobalCategorySelection = (thirdCategoryId) => {
    const id = String(thirdCategoryId || "").trim();
    if (!id) return;
    setFilters((prev) => {
      const current = Array.isArray(prev.globalCategoryThirdIds) ? prev.globalCategoryThirdIds : [];
      const exists = current.includes(id);
      const next = exists ? current.filter((x) => x !== id) : [...current, id];
      return {
        ...prev,
        globalCategoryThirdIds: next,
        globalCategoryThirdId: next.length === 1 ? next[0] : "",
      };
    });
    setPage(1);
  };

  const clearGlobalCategorySelection = () => {
    setFilters((prev) => ({ ...prev, globalCategoryThirdId: "", globalCategoryThirdIds: [] }));
    setPage(1);
  };

  const selectDraftBatch = (batchId) => {
    const id = String(batchId || "").trim();
    if (!id) return;
    setFilters((prev) => ({ ...prev, batchId: id }));
    setBatchPickerOpen(false);
    setPage(1);
  };

  const clearDraftBatchFilter = () => {
    setFilters((prev) => ({ ...prev, batchId: "" }));
    setBatchPickerOpen(false);
    setPage(1);
  };

  const formatMoqFilterLabel = () => {
    const from = String(filters.moqFrom ?? "").trim();
    const to = String(filters.moqTo ?? "").trim();
    if (!from && !to) return "MOQ";
    if (from && to) return `MOQ ${from}–${to}`;
    if (from) return `MOQ ${from}+`;
    return `MOQ ≤${to}`;
  };

  const openMoqPicker = () => {
    setMoqPanelFrom(filters.moqFrom ?? "");
    setMoqPanelTo(filters.moqTo ?? "");
    setMoqPickerOpen((prev) => !prev);
  };

  const handleMoqPanelSearch = () => {
    const from = String(moqPanelFrom ?? "").trim();
    const to = String(moqPanelTo ?? "").trim();
    setFilters((prev) => ({ ...prev, moqFrom: from, moqTo: to }));
    setMoqPickerOpen(false);
    setPage(1);
  };

  const clearMoqFilter = () => {
    setMoqPanelFrom("");
    setMoqPanelTo("");
    setFilters((prev) => ({ ...prev, moqFrom: "", moqTo: "" }));
    setMoqPickerOpen(false);
    setPage(1);
  };

  const clearAllFilters = () => {
    setFilters(INITIAL_DRAFT_FILTERS);
    setGlobalCategoryFacetSearch("");
    setBatchPanelSearch("");
    batchActiveSearchRef.current = "";
    setBatchPickerOpen(false);
    setMoqPickerOpen(false);
    setMoqPanelFrom("");
    setMoqPanelTo("");
    setGlobalCategoryFilterOpen(false);
    setPage(1);
    lastFacetBaseKeyRef.current = "";
    bulkUploadRef.current?.clearUpload?.();
    fetchDraftsList({ filters: INITIAL_DRAFT_FILTERS, page: 1, globalCategoryFacetSearch: "" });
  };

  const loadMoreDraftBatches = () => {
    if (!batchHasMore || batchLoadingMore || batchLoading) return;
    loadBatchRows(batchSuggestions.length, batchActiveSearchRef.current, true);
  };

  const handleBatchPanelSearch = () => {
    const q = String(batchPanelSearch || "").trim();
    batchActiveSearchRef.current = q;
    loadBatchRows(0, q, false);
  };

  const openVariantModal = (row) => setVariantModalRow(row || null);
  const closeVariantModal = () => setVariantModalRow(null);

  const handleExportSkuUploadTemplate = async () => {
    setExportSkuTemplateLoading(true);
    try {
      await productDraftApiService.downloadSkuUploadTemplateForFilteredDrafts(filters);
      message.showToast("SKU upload template downloaded", ToastTypes.SUCCESS);
    } catch (err) {
      message.showToast(err?.message || "Export failed", ToastTypes.WARNING);
    } finally {
      setExportSkuTemplateLoading(false);
    }
  };
  const selectedGlobalCategoryCount = Array.isArray(filters.globalCategoryThirdIds)
    ? filters.globalCategoryThirdIds.length
    : 0;
  const handleEdit = (id) => {
    const editUrl = `/admin/product-drafts/edit/${id}`;
    window.open(editUrl, "_blank", "noopener,noreferrer");
  };
  const handleView = (id) => navigate(`/admin/product-drafts/view/${id}`);
  const handleDelete = (id) => { setId(id); setOpen(true); };
  const handleClose = () => setOpen(false);

  const handleSubmit = () => {
    loader.showLoading(true);
    productDraftApiService.deleteProductDraft(id)
      .then((res) => {
        loader.showLoading(false);
        if (res.status.code === 200) {
          fetchDraftsList();
          setOpen(false);
          message.showToast("Draft deleted", ToastTypes.SUCCESS);
        } else {
          message.showToast(res.error.message, ToastTypes.ERROR);
        }
      })
      .catch((err) => {
        message.showToast(err?.message || "Server error", ToastTypes.ERROR);
        loader.showLoading(false);
      });
  };

  const tableRows = useMemo(() => {
    return (draftData || []).map((item, index) => {
      const { minAp, maxAp, minCp, maxCp } = getVariantMixPrices(item);
      // Get seller info directly from backend response (companyName and sellerOpenId from Product)
      const sellerCompanyName = item.sellerCompanyName || item.companyName || "";
      const sellerOpenId = item.sellerOpenId || "";
      const sellerDisplayName = translatedSellerNames[sellerCompanyName] || sellerCompanyName;
      const sellerDisplay = sellerDisplayName || sellerOpenId || "-";
      
      // Get subscribed users from backend response
      const subscribedUsers = item.subscribedUsers || [];
      const subscriberNames = subscribedUsers.map(u => u.name).filter(n => n && n !== 'Unknown').join(", ");
      
      return {
        _id: item._id,
        serialNumber: (page - 1) * limit + index + 1,
        raw: item,
        image: normalizeUrl(item.thumbnailImage || (item.imgUrl && item.imgUrl[0]) || ""),
        title: item.title || "-",
        sellerName: sellerDisplay,
        sellerCompanyName: sellerCompanyName,
        sellerDisplayName: sellerDisplayName,
        sellerOpenId: sellerOpenId,
        subscriberNames: subscriberNames || "-",
        subscriberCount: subscribedUsers.length,
        sku: item.sku || "-",
        variantCount: Number.isFinite(Number(item.variantCount))
          ? Number(item.variantCount)
          : (Array.isArray(item.variations) ? item.variations.length : 0),
        brand: item.brand || "Generic",
        minAp,
        maxAp,
        minCp,
        maxCp,
        vendor_price: item.vendor_price || 0,
        sp: item.sp || 0,
        status: item.processingStatus || "pending",
        createdAt: item.createdAt,
        location: item.location || "-",
      };
    });
  }, [draftData, page, limit, translatedSellerNames]);

  const columns = useMemo(() => [
    {
      key: "serialNumber",
      label: "#",
      width: 35,
      render: (value) => <span className="pd-serial">{value}</span>,
    },
    {
      key: "image",
      label: "IMAGE",
      width: 65,
      render: (value) => (
        <div className="pd-image-cell">
          {value ? <img src={value} alt="" referrerPolicy="no-referrer" /> : <div className="pd-no-image">-</div>}
        </div>
      ),
    },
    {
      key: "title",
      label: "Product",
      width: 280,
      render: (value, row) => (
        <div className="pd-product-cell">
          <a
            className="pd-product-title"
            href={generateProductUrl({
              id: row.raw?._id,
              offer: row.raw?.offerId,
              isAli: !!row.raw?.offerId,
              title: row.raw?.title,
              variantId: row.raw?.variantId || undefined,
            })}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            {value}
          </a>
        </div>
      ),
    },
    {
      key: "sellerName",
      label: "Seller",
      width: 150,
      render: (value, row) => (
        <div className="pd-seller-cell">
          {row.sellerCompanyName ? (
            <>
              <span className="pd-seller-name" title={row.sellerDisplayName || row.sellerCompanyName}>{truncateText(row.sellerDisplayName || row.sellerCompanyName, 25)}</span>
              {row.sellerOpenId && <span className="pd-seller-id">ID: {row.sellerOpenId}</span>}
            </>
          ) : row.sellerOpenId ? (
            <span className="pd-seller-id">ID: {row.sellerOpenId}</span>
          ) : (
            <span className="pd-no-seller">-</span>
          )}
        </div>
      ),
    },
    {
      key: "sku",
      label: "SKU",
      width: 130,
      render: (value) => <span className="pd-sku">{value}</span>,
    },
    {
      key: "variantCount",
      label: "Variants",
      width: 120,
      render: (value, row) => {
        const count = Number(value || 0);
        const isOpen = variantModalRow?._id && row?._id && String(variantModalRow._id) === String(row._id);
        return (
          <button
            type="button"
            className={`pd-variant-count-btn ${isOpen ? "is-open" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              openVariantModal(row);
            }}
            title={count > 0 ? "Click to Update Weight & Dimensions" : "No variants"}
            disabled={count <= 0}
          >
            {count}
          </button>
        );
      },
    },
    // {
    //   key: "brand",
    //   label: "Brand",
    //   width: 90,
    //   render: (value) => <span className="pd-brand">{value}</span>,
    // },
    {
      key: "vendor_price",
      label: "Vendor Price",
      width: 240,
      render: (_, row) => {
        const fmt = (v) => v != null ? `¥${Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : null;
        const dropshipVal = row.minAp != null
          ? (row.minAp === row.maxAp ? fmt(row.minAp) : `(${fmt(row.minAp)} ~ ${fmt(row.maxAp)})`)
          : "–";
        const cpMin = row.minCp ?? row.maxCp;
        const cpMax = row.maxCp ?? row.minCp;
        const wholesaleVal = cpMin != null || cpMax != null
          ? (cpMin === cpMax ? fmt(cpMin) : `(${fmt(cpMin) ?? "–"} ~ ${fmt(cpMax) ?? "–"})`)
          : "–";
        const priceRangeList = row.raw?.productSaleInfo?.priceRangeList || [];
        const useRangeList = Array.isArray(priceRangeList) && priceRangeList.length > 2;
        return (
          <div className="pd-vendor-price-cell">
            <div className="pd-vendor-block pd-vendor-dropship">
              <span className="pd-vendor-label">Dropship</span>
              <span className="pd-vendor-value">{dropshipVal}</span>
            </div>
            <div className="pd-vendor-block pd-vendor-wholesale">
              <span className="pd-vendor-label">Wholesale</span>
              {useRangeList ? (
                <div className="pd-wholesale-stacked">
                  <div className="pd-wholesale-prices-row">
                    ({priceRangeList.map((r, i) => (
                      <span key={i} className="pd-wholesale-price-item">
                        {fmt(r.price) ?? "–"}{i < priceRangeList.length - 1 ? " ~ " : ""}
                      </span>
                    ))})
                  </div>
                  <div className="pd-wholesale-qty-row">
                    ({priceRangeList.map((r, i) => {
                      const start = r.startQuantity ?? "–";
                      const nextStart = priceRangeList[i + 1]?.startQuantity;
                      const qtyLabel = nextStart ? `${start}-${nextStart - 1}` : `${start}+`;
                      return (
                        <span key={i} className="pd-wholesale-qty-item">
                          ({qtyLabel}){i < priceRangeList.length - 1 ? " - " : ""}
                        </span>
                      );
                    })})
                  </div>
                </div>
              ) : (
                <span className="pd-vendor-value">{wholesaleVal}</span>
              )}
            </div>
          </div>
        );
      },
    },
    {
      key: "sp",
      label: "Selling Price",
      width: 260,
      render: (value, row) => {
        const item = row.raw || {};
        const fmt = (v) => v != null && Number.isFinite(Number(v)) ? formatPrice(Number(v)) : null;
        const vars = item?.variations || [];
        const dropshipPrices = vars.map((v) => v.finalPrice    != null && Number.isFinite(Number(v.finalPrice)) ? Number(v.finalPrice) : null).filter((n) => n != null);
        const wholesalePrices = vars.map((v) => v.wholesaleFinalPrice != null && Number.isFinite(Number(v.wholesaleFinalPrice)) ? Number(v.wholesaleFinalPrice) : null).filter((n) => n != null);
        const minDropship = dropshipPrices.length ? Math.min(...dropshipPrices) : (value != null ? numericValue(value) : null);
        const maxDropship = dropshipPrices.length ? Math.max(...dropshipPrices) : (value != null ? numericValue(value) : null);
        const minWholesale = wholesalePrices.length ? Math.min(...wholesalePrices) : (value != null ? numericValue(value) : null);
        const maxWholesale = wholesalePrices.length ? Math.max(...wholesalePrices) : (value != null ? numericValue(value) : null);
        const dropshipVal = minDropship != null
          ? (minDropship === maxDropship ? fmt(minDropship) : `(${fmt(minDropship)} ~ ${fmt(maxDropship)})`)
          : "–";
        const priceRanges = Array.isArray(item.priceRanges) ? item.priceRanges : [];
        const usePriceRangesForWholesale = priceRanges.length >= 2;
        const wholesaleVal = !usePriceRangesForWholesale && minWholesale != null
          ? (minWholesale === maxWholesale ? fmt(minWholesale) : `(${fmt(minWholesale) ?? "–"} ~ ${fmt(maxWholesale) ?? "–"})`)
          : null;
        return (
          <div className="pd-vendor-price-cell">
            <div className="pd-vendor-block pd-vendor-dropship">
              <span className="pd-vendor-label">Dropship</span>
              <span className="pd-vendor-value">{dropshipVal}</span>
            </div>
            <div className="pd-vendor-block pd-vendor-wholesale">
              <span className="pd-vendor-label">Wholesale</span>
              {usePriceRangesForWholesale ? (
                <div className="pd-wholesale-stacked">
                  <div className="pd-wholesale-prices-row">
                    ({priceRanges.map((r, i) => (
                      <span key={i} className="pd-wholesale-price-item">
                        {fmt(r.finalPrice) ?? "–"}{i < priceRanges.length - 1 ? " ~ " : ""}
                      </span>
                    ))})
                  </div>
                  <div className="pd-wholesale-qty-row">
                    ({priceRanges.map((r, i) => {
                      const start = r.startQuantity ?? "–";
                      const nextStart = priceRanges[i + 1]?.startQuantity;
                      const qtyLabel = nextStart != null ? `${start}-${nextStart - 1}` : `${start}+`;
                      return (
                        <span key={i} className="pd-wholesale-qty-item">
                          ({qtyLabel}){i < priceRanges.length - 1 ? " - " : ""}
                        </span>
                      );
                    })})
                  </div>
                </div>
              ) : (
                <span className="pd-vendor-value">{wholesaleVal ?? "–"}</span>
              )}
            </div>
          </div>
        );
      },
    },
    // {
    //   key: "status",
    //   label: "Status",
    //   width: 90,
    //   render: (value) => (
    //     <span className={`pd-status-badge pd-status-${value?.toLowerCase()}`}>
    //       {value === "pending" || value === "Draft" ? "Draft" : value === "completed" ? "Completed" : value === "processing" ? "Processing" : value === "failed" ? "Failed" : value}
    //     </span>
    //   ),
    // },
    {
      key: "subscriberNames",
      label: "Subscribers",
      width: 150,
      render: (value, row) => (
        <div className="pd-subscribers-cell">
          {row.subscriberCount > 0 ? (
            <>
              <span className="pd-subscriber-count">{row.subscriberCount} user(s)</span>
              <span className="pd-subscriber-names" title={value}>{truncateText(value, 30)}</span>
            </>
          ) : (
            <span className="pd-no-subscribers">0</span>
          )}
        </div>
      ),
    },
    {
      key: "createdAt",
      label: "Created",
      width: 95,
      render: (value) => <span className="pd-date">{formatDate(value)}</span>,
    },
    // {
    //   key: "location",
    //   label: "Location",
    //   width: 70,
    //   render: (value) => <span className="pd-location">{value}</span>,
    // },
    {
      key: "actions",
      label: "Actions",
      width: 100,
      render: (_, row) => {
        const item = row.raw || {};
        return (
          <div className="pd-actions-cell">
            <button className="pd-action-btn pd-action-edit" onClick={(e) => { e.stopPropagation(); handleEdit(item._id); }} title="Edit"><MdModeEdit /></button>
            {/* <button className="pd-action-btn pd-action-view" onClick={(e) => { e.stopPropagation(); handleView(item._id); }} title="View"><MdDescription /></button> */}
            <button className="pd-action-btn pd-action-delete" onClick={(e) => { e.stopPropagation(); handleDelete(item._id); }} title="Delete"><MdDelete /></button>
          </div>
        );
      },
    },
  ], [variantModalRow]);


  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, pages.totalItems);

  const toolbarLeftActions = (
    <div className="pd-toolbar-left">
      <div className="pd-search-with-action">
        <div className="pd-search-box">
          <FaSearch className="pd-search-icon" />
          <input type="text" className="pd-search-input" placeholder="Search name, SKU..." name="search" value={filters.search} onChange={handleOnChange} onKeyUp={(e) => e.key === "Enter" && searchDrafts()} />
        </div>
        <button type="button" className="pd-search-btn" onClick={searchDrafts}><FaSearch /> Search</button>
      </div>
      <div className="pd-toolbar-filters">
        <select
          className={`pd-filter-select${filters.status ? " pd-batch-toggle--active" : ""}`}
          value={filters.status}
          title="Filter by product status"
          onChange={(e) => {
            setFilters((prev) => ({ ...prev, status: e.target.value }));
            setPage(1);
          }}
        >
          <option value="">All</option>
          <option value="6">Draft</option>
          <option value="5">List</option>
        </select>
        <select
          className={`pd-filter-select${filters.errorFilter ? " pd-batch-toggle--active" : ""}`}
          value={filters.errorFilter}
          title="Filter drafts by dimension/weight errors"
          onChange={(e) => {
            const value = e.target.value;
            setFilters((prev) => ({
              ...prev,
              errorFilter: value,
              globalCategoryThirdId: "",
              globalCategoryThirdIds: [],
            }));
            setPage(1);
          }}
        >
          <option value="">All products</option>
          <option value="only">Product with error</option>
          <option value="withoutError">Product without error</option>
        </select>
      </div>
      {/* Curruntly not used may enable later */}
      {/* <select className="pd-filter-select" value={filters.source} onChange={(e) => setFilters({ ...filters, source: e.target.value })}>
        <option value="">All Sources</option>
        <option value="alibaba">Global</option>
      </select> */}
    </div>
  );

  const batchFilterPanel = (
    <div className="pd-batch-filter pd-batch-filter--bulk" ref={batchFilterRef}>
      <button
        type="button"
        className={`pd-filter-select pd-batch-toggle${filters.batchId ? " pd-batch-toggle--active" : ""}`}
        title="Filter drafts by SKU upload batch ID"
        onClick={() => setBatchPickerOpen((prev) => !prev)}
      >
        {filters.batchId ? truncateText(filters.batchId, 26) : "Batch ID"}
      </button>
      {batchPickerOpen ? (
        <div className="pd-batch-panel" role="listbox" aria-label="SKU upload batches">
          <div className="pd-batch-search-row">
            <input
              type="text"
              className="pd-batch-search-input"
              placeholder="Search batch id…"
              value={batchPanelSearch}
              onChange={(e) => setBatchPanelSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleBatchPanelSearch();
                }
              }}
              autoComplete="off"
            />
            <button type="button" className="pd-batch-search-submit" onClick={handleBatchPanelSearch}>
              <FaSearch aria-hidden /> Search
            </button>
          </div>
          <div className="pd-batch-list">
            {batchLoading && batchSuggestions.length === 0 ? (
              <div className="pd-batch-empty">Loading…</div>
            ) : null}
            {!batchLoading && batchSuggestions.length === 0 ? (
              <div className="pd-batch-empty">No batches found</div>
            ) : null}
            {batchSuggestions.map((b) => (
              <button
                key={b.batchId}
                type="button"
                className="pd-batch-row"
                role="option"
                onClick={() => selectDraftBatch(b.batchId)}
              >
                <span className="pd-batch-id">{b.batchId}</span>
                <span className="pd-batch-meta">
                  {[b.status, b.jobType].filter(Boolean).join(" · ")}
                  {b.startedAt ? ` · ${formatDate(b.startedAt)}` : ""}
                </span>
              </button>
            ))}
          </div>
          <div className="pd-batch-footer">
            <button type="button" className="pd-batch-clear" onClick={clearDraftBatchFilter}>
              Clear filter
            </button>
            {batchHasMore ? (
              <button
                type="button"
                className="pd-batch-more"
                disabled={batchLoadingMore || batchLoading}
                onClick={loadMoreDraftBatches}
              >
                {batchLoadingMore ? "Loading…" : "Show more"}
              </button>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );

  const moqFilterPanel = (
    <div className="pd-batch-filter pd-moq-filter-wrap" ref={moqFilterRef}>
      <button
        type="button"
        className={`pd-filter-select pd-batch-toggle${filters.moqFrom || filters.moqTo ? " pd-batch-toggle--active" : ""}`}
        title="Filter by MOQ range (inclusive)"
        onClick={openMoqPicker}
      >
        {formatMoqFilterLabel()}
      </button>
      {moqPickerOpen ? (
        <div className="pd-batch-panel pd-moq-panel" role="dialog" aria-label="MOQ range filter">
          <div className="pd-moq-search-row">
            <div className="pd-moq-field">
              <span className="pd-moq-field-label">From</span>
              <input
                type="number"
                className="pd-moq-panel-input"
                min="0"
                step="1"
                placeholder="1"
                value={moqPanelFrom}
                onChange={(e) => setMoqPanelFrom(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleMoqPanelSearch();
                  }
                }}
                autoComplete="off"
              />
            </div>
            <span className="pd-moq-sep">–</span>
            <div className="pd-moq-field">
              <span className="pd-moq-field-label">To</span>
              <input
                type="number"
                className="pd-moq-panel-input"
                min="0"
                step="1"
                placeholder="5"
                value={moqPanelTo}
                onChange={(e) => setMoqPanelTo(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleMoqPanelSearch();
                  }
                }}
                autoComplete="off"
              />
            </div>
            <button type="button" className="pd-batch-search-submit" onClick={handleMoqPanelSearch}>
              <FaSearch aria-hidden /> Search
            </button>
          </div>
          <div className="pd-batch-footer">
            <button type="button" className="pd-batch-clear" onClick={clearMoqFilter}>
              Clear filter
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );

  const toolbarRightActions = (
    <div className="pd-toolbar-right">
      <button className="pd-refresh-btn" onClick={fetchDraftsList} title="Refresh"><FaSync className={loading ? "pd-spin" : ""} /></button>
      <button className="pd-toolbar-btn" onClick={handleExportCsv} title="Export Catalog rows present in the table as Excel file"><FaDownload /> Export Catalog</button>
      <button className="pd-toolbar-btn pd-btn-success" onClick={handleBulkPublish} disabled={!selectedDrafts.length}><FaCheckCircle /> Publish</button>
      <button className="pd-toolbar-btn pd-btn-danger" onClick={handleBulkDelete} disabled={!selectedDrafts.length}><FaTrash /> Delete</button>
      <div className="pd-rows-picker">
        <span>Rows:</span>
        <select value={limit} onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }}>
          {[10, 20, 50, 100].map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>
    </div>
  );

  return (
    <div className="pd-page">
      <div className="pd-table-section">
        <div className="pd-bulk-upload-row">
          <BulkDimensionUpdate ref={bulkUploadRef} onUpdateComplete={fetchDraftsList} />
          <div className="pd-bulk-upload-right">
            {batchFilterPanel}
            {moqFilterPanel}
            <select
              className={`pd-filter-select${filters.isWhiteImageAvailable ? " pd-batch-toggle--active" : ""}`}
              value={filters.isWhiteImageAvailable}
              title="Filter by white image availability"
              onChange={(e) => {
                setFilters((prev) => ({ ...prev, isWhiteImageAvailable: e.target.value }));
                setPage(1);
              }}
            >
              <option value="">White image</option>
              <option value="true">White image: Yes</option>
              <option value="false">White image: No</option>
            </select>
            <div className="pd-global-cat-filter" ref={globalCategoryFilterRef}>
              <button
                type="button"
                className="pd-filter-select pd-global-cat-toggle"
                title="Global category filter (search + multi select)"
                onClick={() => setGlobalCategoryFilterOpen((prev) => !prev)}
              >
                {selectedGlobalCategoryCount > 0
                  ? `${selectedGlobalCategoryCount} categories selected`
                  : "All global categories"}
              </button>
              {globalCategoryFilterOpen && (
                <div className="pd-global-cat-panel">
                  <input
                    type="text"
                    className="pd-global-cat-search"
                    placeholder="Search category name or ID"
                    value={globalCategoryFacetSearch}
                    onChange={(e) => setGlobalCategoryFacetSearch(e.target.value)}
                  />
                  {!isCategoryIdSearch && normalizedCategorySearch.length > 0 && normalizedCategorySearch.length < 3 && (
                    <div className="pd-global-cat-search-note">Type at least 3 characters to search by name</div>
                  )}
                  <div className="pd-global-cat-list">
                    {globalCategoryFacets.map((opt) => {
                      const checked = (filters.globalCategoryThirdIds || []).includes(String(opt.thirdCategoryId));
                      return (
                        <label
                          key={opt.thirdCategoryId}
                          className={`pd-global-cat-item ${checked ? "is-checked" : ""}`}
                          title={`${opt.pathLabel} · thirdCategoryId: ${opt.thirdCategoryId} · ${opt.count} drafts`}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => toggleGlobalCategorySelection(opt.thirdCategoryId)}
                          />
                          <span>{opt.pathLabel} · ID {opt.thirdCategoryId} ({opt.count})</span>
                        </label>
                      );
                    })}
                    {!globalCategoryFacetLoading && globalCategoryFacets.length === 0 && (
                      <div className="pd-global-cat-empty">No category found</div>
                    )}
                  </div>
                  <div className="pd-global-cat-footer">
                    <button
                      type="button"
                      className="pd-global-cat-clear"
                      onClick={clearGlobalCategorySelection}
                    >
                      Clear
                    </button>
                    <span className="pd-global-cat-total">Total categories: {globalCategoryFacetTotal}</span>
                    {globalCategoryFacetHasMore && (
                      <button
                        type="button"
                        className="pd-global-cat-more"
                        disabled={globalCategoryFacetLoading}
                        onClick={() =>
                          fetchGlobalCategoryFacets({
                            append: true,
                            offset: globalCategoryFacetOffset,
                            searchTerm: globalCategoryFacetSearch,
                          })
                        }
                      >
                        {globalCategoryFacetLoading ? "Loading..." : "Show more"}
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
            {/* Date filters — enable when needed
            <motion.div className="pd-date-filter" title="Filter by draft created date">
              <input
                type="date"
                className="pd-date-input"
                name="createdFrom"
                value={filters.createdFrom}
                onChange={(e) => {
                  setFilters((prev) => ({ ...prev, createdFrom: e.target.value }));
                  setPage(1);
                }}
                aria-label="Created from"
              />
              <span className="pd-date-sep">–</span>
              <input
                type="date"
                className="pd-date-input"
                name="createdTo"
                value={filters.createdTo}
                onChange={(e) => {
                  setFilters((prev) => ({ ...prev, createdTo: e.target.value }));
                  setPage(1);
                }}
                aria-label="Created to"
              />
            </motion.div>
            */}
            <button
              type="button"
              className="pd-clear-filters-btn"
              title="Clear search, status, batch, MOQ, category, and error filters"
              onClick={clearAllFilters}
            >
              Clear filters
            </button>
            <button
              type="button"
              className="pd-sku-template-export-btn"
              title="Download SKU Excel based on current filters"
              disabled={exportSkuTemplateLoading}
              onClick={handleExportSkuUploadTemplate}
            >
              {exportSkuTemplateLoading ? <FaSync className="pd-spin" /> : <FaDownload />}
              {exportSkuTemplateLoading ? "Exporting..." : "Export SKUs"}
            </button>
          </div>
        </div>
        <ExcelTable
          data={tableRows}
          columns={columns}
          isLoading={initialLoading || loading}
          loadingText="Loading product drafts..."
          showToolbarExport={false}
          showToolbarFilter={false}
          showToolbarColumns={true}
          showToolbarFullscreen={true}
          toolbarLeftActions={toolbarLeftActions}
          toolbarRightActions={toolbarRightActions}
          onSelectionChange={(rows) => setSelectedDrafts(rows)}
          selectedData={selectedDrafts}
          selectable={true}
          sortable={true}
          resizable={true}
          showToolbar={true}
          // title="Product Drafts"
          title=""
          userId={currentUserId}
          tableName="product-drafts"
        />

        {draftData.length > 0 && pages.totalPages > 1 && (
          <div className="pd-pagination">
            <div className="pd-pagination-info">Showing {startItem} to {endItem} of {pages.totalItems} drafts</div>
            <div className="pd-pagination-controls">
              <button className="pd-page-btn" disabled={page <= 1} onClick={() => setPage(page - 1)}>‹</button>
              {Array.from({ length: Math.min(5, pages.totalPages) }, (_, i) => {
                let pageNum;
                if (pages.totalPages <= 5) pageNum = i + 1;
                else if (page <= 3) pageNum = i + 1;
                else if (page >= pages.totalPages - 2) pageNum = pages.totalPages - 4 + i;
                else pageNum = page - 2 + i;
                return (
                  <button key={pageNum} className={`pd-page-btn ${page === pageNum ? "pd-page-btn-active" : ""}`} onClick={() => setPage(pageNum)}>{pageNum}</button>
                );
              })}
              {pages.totalPages > 5 && page < pages.totalPages - 2 && (
                <>
                  <span className="pd-page-dots">...</span>
                  <button className="pd-page-btn" onClick={() => setPage(pages.totalPages)}>{pages.totalPages}</button>
                </>
              )}
              <button className="pd-page-btn" disabled={page >= pages.totalPages} onClick={() => setPage(page + 1)}>›</button>
            </div>
          </div>
        )}
      </div>

      <DeletePopUp heading="Delete Draft" text="Are you sure you want to delete this draft?" open={open} handleClose={handleClose} submitText="Yes" cancelText="No" handleSubmit={handleSubmit} handleCancel={handleClose} />

      <VariantDetailsModal
        open={!!variantModalRow}
        rowData={variantModalRow}
        onClose={closeVariantModal}
        onUpdated={fetchDraftsList}
      />
      
      {/* Export Processing Modal */}
      {exportProcessing && (
        <div className="export-processing-modal-backdrop">
          <div className="export-processing-modal">
            <div className="export-processing-modal-content">
              <div className="export-processing-spinner">
                <FaSync className="pd-spin" style={{ fontSize: '24px', color: '#2563eb' }} />
              </div>
              <div className="export-processing-text">
                <h3>Exporting Data</h3>
                <p>{exportStatus || "Processing..."}</p>
                <div className="export-progress-bar-container">
                  <div className="export-progress-bar">
                    <div 
                      className="export-progress-bar-fill" 
                      style={{ width: `${exportProgress}%` }}
                    ></div>
                  </div>
                  <div className="export-progress-percentage">{exportProgress}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
